import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthForm from '../components/AuthForm';
import Spline3D from '../components/Spline3D';
import { Sparkles, Shield, Zap, Users } from 'lucide-react';

const AuthPage = () => {
  const navigate = useNavigate();
  const [mode, setMode] = useState('login');

  const handleSuccess = () => {
    navigate('/');
  };

  const toggleMode = () => {
    setMode(prev => prev === 'login' ? 'signup' : 'login');
  };

  return (
    <div style={{ background: '#0B0F13', minHeight: '100vh' }}>
      {/* Header */}
      <header
        className="fixed top-0 w-full z-50 glass-strong"
        style={{
          borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
          padding: '16px 7.6923%',
          height: '80px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate('/')}>
          <Sparkles className="w-8 h-8 glow-cyan" style={{ color: '#00FFD1' }} />
          <span className="text-2xl font-bold text-glow" style={{ color: '#FFFFFF', fontWeight: 700 }}>
            Elite Plugin Hub
          </span>
        </div>

        <button
          onClick={() => navigate('/')}
          className="text-lg transition-colors duration-300 hover:text-[#00FFD1]"
          style={{ color: 'rgba(255, 255, 255, 0.85)' }}
        >
          Browse Plugins
        </button>
      </header>

      {/* Main Content */}
      <div style={{ paddingTop: '80px' }}>
        <div className="container mx-auto px-8 md:px-16 py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Left: Auth Form */}
            <div>
              <AuthForm 
                mode={mode} 
                onToggleMode={toggleMode}
                onSuccess={handleSuccess}
              />
            </div>

            {/* Right: Premium Features */}
            <div className="space-y-8">
              <div className="text-center lg:text-left">
                <h1
                  className="text-5xl md:text-6xl font-bold leading-tight mb-6"
                  style={{
                    color: '#FFFFFF',
                    fontWeight: 800,
                    letterSpacing: '-0.02em',
                    fontFamily: 'Orbitron, sans-serif',
                  }}
                >
                  {mode === 'login' ? 'Welcome Back' : 'Join Elite'}
                </h1>
                <p className="text-xl mb-8" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
                  {mode === 'login' 
                    ? 'Access your premium plugins and continue your journey' 
                    : 'Create your account and unlock exclusive features'
                  }
                </p>
              </div>

              {/* Features */}
              <div className="space-y-6">
                {[
                  {
                    icon: Shield,
                    title: 'Secure Authentication',
                    description: 'Protected with email verification'
                  },
                  {
                    icon: Zap,
                    title: 'Instant Access',
                    description: 'Get immediate access to premium plugins after verification'
                  },
                  {
                    icon: Users,
                    title: 'Exclusive Community',
                    description: 'Join our Discord community for support and updates'
                  }
                ].map((feature, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-4 p-4 glass hover:glass-strong transition-all duration-300"
                    style={{ borderRadius: '0px' }}
                  >
                    <div className="w-12 h-12 bg-gradient-to-r from-[#00FFD1] to-[#0EA5FF] rounded flex items-center justify-center flex-shrink-0">
                      <feature.icon className="w-6 h-6 text-black" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold mb-1" style={{ color: '#FFFFFF' }}>
                        {feature.title}
                      </h3>
                      <p className="text-sm" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
                        {feature.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* 3D Element */}
              <div className="flex justify-center lg:justify-start">
                <div className="w-64 h-64">
                  <Spline3D />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;